import { Base } from '@itsrever/design-system'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router'
import {
  FILTER_KEYS,
  useProcessFilters,
  type FilterKey
} from './helpers/use-process-filters'

type ActivePill = {
  key: FilterKey
  value: string
  categoryLabel: string
  valueLabel: string
}

export const FilterPills = () => {
  const { t } = useTranslation()
  const [searchParams, setSearchParams] = useSearchParams()
  const filters = useProcessFilters()

  const pills: ActivePill[] = FILTER_KEYS.flatMap((key) => {
    const values = searchParams.getAll(key)
    if (values.length === 0) return []
    const config = filters.find((f) => f.key === key)
    const categoryLabel = t(`orders.filter_categories.${key}`)
    return values.map((value) => ({
      key,
      value,
      categoryLabel,
      valueLabel: config?.options.find((o) => o.value === value)?.label ?? value
    }))
  })

  if (pills.length === 0) return null

  const removePill = (key: FilterKey, value: string) => {
    const remaining = searchParams.getAll(key).filter((v) => v !== value)
    searchParams.delete(key)
    for (const v of remaining) searchParams.append(key, v)
    searchParams.delete('page')
    setSearchParams(searchParams)
  }

  return (
    <div className="flex flex-wrap gap-2 pt-3">
      {pills.map((pill) => (
        <Base.Chip
          key={`${pill.key}:${pill.value}`}
          onRemove={() => removePill(pill.key, pill.value)}
          removeLabel={t('orders.remove_filter', {
            category: pill.categoryLabel,
            value: pill.valueLabel
          })}
        >
          {pill.categoryLabel}: {/* Country names come lower-cased. */}
          <span className="capitalize">{pill.valueLabel}</span>
        </Base.Chip>
      ))}
    </div>
  )
}
